// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__P3M4T {
  position: sticky;
  left: 0px;
  right: 0px;
  top: 0px;
}
.styles_wrapper__P3M4T .styles_header__NyX8e {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0px 80px;
  height: 80px;
  background: rgba(50, 117, 195, 0.7);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.styles_wrapper__P3M4T .styles_header__NyX8e > div {
  display: flex;
  align-items: center;
  gap: 24px;
  color: white;
}
.styles_wrapper__P3M4T .styles_header__NyX8e > div img {
  height: 40px;
  cursor: pointer;
}
.styles_wrapper__P3M4T .styles_header__NyX8e button {
  height: max-content;
}
.styles_wrapper__P3M4T .styles_offcanvas__HulSS {
  width: 80% !important;
}
.styles_wrapper__P3M4T .styles_offcanvas__HulSS .styles_logo_text__hC2-x {
  color: #3275c3;
}
.styles_wrapper__P3M4T .styles_offcanvas__HulSS .styles_offcanvas_body__gw10h {
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.styles_wrapper__P3M4T .styles_offcanvas__HulSS .styles_offcanvas_body__gw10h > div {
  width: -moz-fit-content;
  width: fit-content;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  color: #000000;
  opacity: 0.5;
  padding-bottom: 4px;
}
.styles_wrapper__P3M4T .styles_offcanvas__HulSS .styles_offcanvas_body__gw10h > div:hover {
  opacity: 0.6;
}
.styles_wrapper__P3M4T .styles_offcanvas__HulSS .styles_offcanvas_body__gw10h > div.styles_active__86wLO {
  font-weight: 700;
  color: #3275c3;
  opacity: 1;
  border-bottom: 3px solid #3275c3;
}

@media screen and (max-width: 991.98px) {
  .styles_wrapper__P3M4T .styles_header__NyX8e {
    padding: 0px 40px;
  }
}
@media screen and (max-width: 576.98px) {
  .styles_wrapper__P3M4T .styles_header__NyX8e {
    padding: 0px 8px;
    height: 60px;
    gap: 0px;
  }
  .styles_wrapper__P3M4T .styles_header__NyX8e > img {
    width: 80px;
    left: calc(50% - 40px);
  }
}
@media screen and (max-width: 340.98px) {
  .styles_wrapper__P3M4T .styles_header__NyX8e img {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/styles.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAKA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;AAJF;AAME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAfQ;EAgBR,mCCjBQ;EDkBR,mCAAA;UAAA,2BAAA;AAJJ;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAJN;AAMM;EACE,YAAA;EACA,eAAA;AAJR;AAQI;EACE,mBAAA;AANN;AAUE;EACE,qBAAA;AARJ;AAUI;EACE,cC1CI;ADkCV;AAWI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wCAAA;AATN;AAWM;EACE,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AATR;AAWQ;EACE,YAAA;AATV;AAYQ;EACE,gBAAA;EACA,cCrEA;EDsEA,UAAA;EACA,gCAAA;AAVV;;AAiBA;EACE;IACE,iBAAA;EAdF;AACF;AAiBA;EACE;IACE,gBAAA;IACA,YApFQ;IAqFR,QAAA;EAfF;EAiBE;IACE,WAAA;IACA,sBAAA;EAfJ;AACF;AAmBA;EACE;IACE,aAAA;EAjBF;AACF","sourcesContent":["@import '../../styles/theme.scss';\r\n\r\n$header-lg: 80px;\r\n$header-sm: 60px;\r\n\r\n.wrapper {\r\n  position: sticky;\r\n  left: 0px;\r\n  right: 0px;\r\n  top: 0px;\r\n\r\n  .header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 0px 80px;\r\n    height: $header-lg;\r\n    background: $header-bg;\r\n    backdrop-filter: blur(10px);\r\n\r\n    >div {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 24px;\r\n      color: white;\r\n\r\n      img {\r\n        height: 40px;\r\n        cursor: pointer;\r\n      }\r\n    }\r\n\r\n    button {\r\n      height: max-content;\r\n    }\r\n  }\r\n\r\n  .offcanvas {\r\n    width: 80% !important;\r\n\r\n    .logo_text {\r\n      color: $primary;\r\n    }\r\n\r\n    .offcanvas_body {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 20px;\r\n      border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n\r\n      >div {\r\n        width: fit-content;\r\n        font-weight: 400;\r\n        font-size: 14px;\r\n        line-height: 18px;\r\n        text-transform: uppercase;\r\n        user-select: none;\r\n        cursor: pointer;\r\n        color: #000000;\r\n        opacity: 0.5;\r\n        padding-bottom: 4px;\r\n\r\n        &:hover {\r\n          opacity: 0.6;\r\n        }\r\n\r\n        &.active {\r\n          font-weight: 700;\r\n          color: $primary;\r\n          opacity: 1;\r\n          border-bottom: 3px solid $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991.98px) {\r\n  .wrapper .header {\r\n    padding: 0px 40px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 576.98px) {\r\n  .wrapper .header {\r\n    padding: 0px 8px;\r\n    height: $header-sm;\r\n    gap: 0px;\r\n\r\n    >img {\r\n      width: 80px;\r\n      left: calc(50% - 40px);\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 340.98px) {\r\n  .wrapper .header img {\r\n    display: none;\r\n  }\r\n}","$primary: #3275c3;\r\n$header-bg: rgb(50, 117, 195, 0.7);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__P3M4T`,
	"header": `styles_header__NyX8e`,
	"offcanvas": `styles_offcanvas__HulSS`,
	"logo_text": `styles_logo_text__hC2-x`,
	"offcanvas_body": `styles_offcanvas_body__gw10h`,
	"active": `styles_active__86wLO`
};
export default ___CSS_LOADER_EXPORT___;
